import { render } from "./ManagementPanel.vue?vue&type=template&id=b59a9e52"
import script from "./ManagementPanel.vue?vue&type=script&lang=js"
export * from "./ManagementPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__